import api from "@/api/work-histories";

export default {
  state: {},
  mutations: {},
  actions: {
    async searchWorkHistories(context, searchCriteria, management_id = null) {
      try {
        if (management_id == null) {
          management_id = await context.dispatch("showManagementID");
        }
        const res = await api.search(
          management_id,
          await context.dispatch("showAccountID"),
          searchCriteria
        );
        return res.data;
      } catch (error) {
        throw error;
      }
    },

    async showWorkHistories(context, id, management_id = null) {
      try {
        if (management_id == null) {
          management_id = await context.dispatch("showManagementID");
        }
        const res = await api.show(
          management_id,
          id,
          await context.dispatch("showAccountID")
        );
        return res.data;
      } catch (error) {
        throw error;
      }
    },

    async insertWorkHistories(
      context,
      {
        paddyFields,
        season,
        item,
        workItems,
        workHistoryIdMap,
        imagePaths,
        areaTotal
      }
    ) {
      try {
        await api.bulkCreate(
          await context.dispatch("showManagementID"),
          paddyFields,
          season,
          item,
          workItems,
          workHistoryIdMap,
          imagePaths,
          areaTotal,
          await context.dispatch("showAccountID"),
          await context.dispatch("showUserId")
        );
      } catch (error) {
        throw error;
      }
    },

    async updateWorkHistory(context, { workHistory, workItems, imagePaths }) {
      try {
        await api.update(
          await context.dispatch("showManagementID"),
          workHistory,
          workItems,
          imagePaths,
          await context.dispatch("showAccountID"),
          await context.dispatch("showUserId")
        );
      } catch (error) {
        throw error;
      }
    },

    async deleteWorkHistory(context, { id }) {
      try {
        const res = await api.del(
          await context.dispatch("showManagementID"),
          id,
          await context.dispatch("showAccountID"),
          await context.dispatch("showUserId")
        );
        return res.data;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {}
};
